import { Directive, OnDestroy, OnInit, output, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { ApDiacriticsNormalizeService } from './diacritics-normalize.service';

@Directive({
    selector: '[apDiacriticsNormalizeFormValue]',
    providers: [ApDiacriticsNormalizeService]
})
export class ApDiacriticsNormalizeFormValueDirective implements OnInit, OnDestroy {
    private readonly diacriticsNormalizeService = inject(ApDiacriticsNormalizeService);
    protected model = inject(NgControl);

    /**
     * Outputs on model change.
     * Emits if value has diacritics
     */
    public readonly hasDiacritics = output<boolean>();

    private readonly destroy$ = new Subject<void>();

    public ngOnInit(): void {
        this.model.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(this.normalizeDiacriticsFormValue.bind(this));
        this.normalizeDiacriticsFormValue(this.model.value);
    }

    public ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private normalizeDiacriticsFormValue(value: string): void {
        const newValue = this.diacriticsNormalizeService.normalize(value);
        if (newValue === value) {
            this.hasDiacritics.emit(false);
            return;
        }
        this.model.control.setValue(newValue);
        this.model.valueAccessor.writeValue(value);
        this.hasDiacritics.emit(true);
    }
}
